import { atom } from 'jotai'
import { atomWithStorage, loadable } from 'jotai/utils'
import {
  dashboardv99990101Client,
  Dashboardv99990101Api
} from '@sequencehq/api/dashboard/v99990101'
import { Model } from './types'

export type ExtractionData = {
  contract: Dashboardv99990101Api.PostContractsProcess.PostContractsProcessResponse
  sequenceRequestId: string | null
}

const extractionResultAtom = atom<null | Promise<ExtractionData | null>>(null)

export const loadableExtractionResultAtom = loadable(extractionResultAtom)

export const promptAtom = atomWithStorage<string | undefined>(
  'contract-extraction-prompt',
  undefined,
  undefined,
  { getOnInit: true }
)
export const modelAtom = atomWithStorage<Model | undefined>(
  'contract-extraction-model',
  undefined,
  undefined,
  { getOnInit: true }
)

export const performExtractionAtom = atom(null, (get, set, assetId: string) => {
  const prompt = get(promptAtom)
  const model = get(modelAtom)
  set(extractionResultAtom, getExtractionResult(assetId, prompt, model))
})

const getExtractionResult = async (
  assetId: string,
  systemPrompt: string | undefined,
  model: Model | undefined
): Promise<ExtractionData> => {
  const configuration = {
    model,
    systemPrompt
  }

  const result = await dashboardv99990101Client.postContractsProcess({
    assetId,
    configuration
  })

  if (!result.data || result.error) {
    const sequenceRequestId = result.res.headers.get('sequence-request-id')
    throw new Error(
      `Unable to process contract extraction for assetId ${assetId}. Model: ${model}. Sequence request id: ${sequenceRequestId}`
    )
  }

  return {
    contract: result.data,
    sequenceRequestId: result.res.headers.get('sequence-request-id')
  }
}

export const contractIdAtom = atom<string | undefined>()

export const visiblePreviewFieldPathsAtom = atom<string[] | undefined>()

export const isContractExtractionEnabledExternallyAtom = atom<boolean>(true)
